import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { getBookLinks, getPrimaryNavLinks, getSecondaryNavLinks } from './navlinks';
var koPrimaryNav = getPrimaryNavLinks(['학습', '과제', '숙제 도움', '주제 이해하기', '작문과 인용', '도구', '전문가 Q&A', '교과서 해답', '수학 해결사', '인용', '표절 검사기', '문법 검사기', '전문가 검토', '커리어', '부트캠프', '커리어 자문', '학습 랩']);
var koSecondaryNav = getSecondaryNavLinks(['교육자용', '도움말', '로그인']);
var koBooks = getBookLinks(['서적', '대여/구매', '읽기', '반납', '판매']);
export var koreanContentIntl = {
  PrimaryNav: koPrimaryNav,
  SecondaryNav: koSecondaryNav,
  experimentIds: []
};
export var koreanContentUS = {
  PrimaryNav: [koBooks].concat(_toConsumableArray(koPrimaryNav)),
  SecondaryNav: koSecondaryNav,
  experimentIds: []
};